
import { Options, Vue } from 'vue-class-component';
import {
  Dialog, DialogOverlay, TransitionChild, TransitionRoot,
} from '@headlessui/vue';
import {
  MenuIcon,
  XIcon,
  LocationMarkerIcon,
  PencilIcon,
  CalendarIcon,
  ScaleIcon,
} from '@heroicons/vue/outline';
import { ChevronLeftIcon } from '@heroicons/vue/solid';
import YearShowList from '@/components/YearShowList.vue';
import AddEditCategorySlideOver from '@/components/SlideOvers/AddEditCategorySlideOver.vue';
import IShow from '@/models/interfaces/IShow';
import ShowCategoryList from '@/components/ShowCategoryList.vue';
import EditShowModal from '@/components/modals/EditShowModal.vue';
import ICategory from '@/models/interfaces/ICategory';
import AreYouSureModal from '@/components/modals/AreYouSureModal.vue';

@Options({
  components: {
    AreYouSureModal,
    EditShowModal,
    ShowCategoryList,
    AddEditCategorySlideOver,
    YearShowList,
    ScaleIcon,
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
    ChevronLeftIcon,
    MenuIcon,
    XIcon,
    LocationMarkerIcon,
    PencilIcon,
    CalendarIcon,
  },
})
export default class Show extends Vue {
  addEditOpen = false;

  editModalOpen = false;

  editingItem: ICategory | null = null;

  currentShow: IShow | null = null;

  areYouSureDeleteOpen = false;

  created(): void {
    this.loadShows();
  }

  get year(): string {
    return Array.isArray(this.$route.params.year) ? this.$route.params.year[0] : this.$route.params.year;
  }

  get slug(): string {
    return Array.isArray(this.$route.params.slug) ? this.$route.params.slug[0] : this.$route.params.slug;
  }

  get showDate(): string {
    const options = {
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
    };
    return this.currentShow ? new Date(this.currentShow.date).toLocaleDateString('en-GB', options) : '';
  }

  // eslint-disable-next-line class-methods-use-this
  addCategoryClicked(): void {
    this.$store.dispatch('addCategory');
    this.addEditOpen = true;
  }

  editDetails() {
    this.editModalOpen = true;
  }

  editItem(editCategory: ICategory) {
    this.$store.dispatch('editCategory', editCategory);
    this.addEditOpen = true;
  }

  // eslint-disable-next-line class-methods-use-this
  closeSlideover(refresh: boolean): void {
    this.addEditOpen = false;
    if (refresh) {
      this.loadShows();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  closeEditModal(refresh: boolean): void {
    this.editModalOpen = false;
    if (refresh) {
      this.loadShows();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  loadShows(): void {
    console.log('Loading shows...');
    this.axios.get(`${process.env.VUE_APP_APIURL}/years/${this.year}/shows/${this.slug}`)
      .then((res) => {
        console.log(res);
        this.currentShow = res.data;
      });
  }

  deleteShow(): void {
    this.areYouSureDeleteOpen = true;
  }

  // eslint-disable-next-line class-methods-use-this
  confirmDelete(): void {
    console.log('deleting');
    this.axios.delete(`${process.env.VUE_APP_APIURL}/years/${this.year}/shows/${this.slug}`)
      .then((res) => {
        this.$router.push({ name: 'Year', params: { year: this.year } });
      });
  }
}
